// extracted by mini-css-extract-plugin
export default {"custom-url":"custom-url--5uZNWdYx8p","customUrl":"custom-url--5uZNWdYx8p"};